export enum TipoCategoriaRetornoBancarioEnum {
    UsarCategoriaInformadaContaReceber = 1,
    UsarUmaCategoriaEspecifica = 2
}
